import { Controller } from "@hotwired/stimulus"

// Simple master/items check-all. Used on the per-agent tool selection form
// (/manage/insight_agent_tools/:agent_key). One controller instance per
// owner section (admin/user/meta_mcp), so checking "all" in the meta_mcp
// group doesn't blow away the admin selection.
//
// Targets:
//   - master: the "check all" checkbox in the header
//   - item:   each tool checkbox in the group
//
// Console logs prefixed [check-all] per CLAUDE.md rule 21.
export default class extends Controller {
  static targets = ["master", "item"]

  connect() {
    console.log(`[check-all] connect: ${this.itemTargets.length} items, master=${this.hasMasterTarget}`)
    this.syncMaster()
  }

  toggleAll(event) {
    const checked = event.target.checked
    console.log(`[check-all] toggleAll → ${checked} (${this.itemTargets.length} items)`)
    this.itemTargets.forEach((cb) => { cb.checked = checked })
  }

  // Keep the master checkbox in sync when individual items change
  // (delegated via a single listener — no per-item action attr needed).
  itemTargetConnected(el) {
    el.addEventListener("change", () => this.syncMaster())
  }

  syncMaster() {
    if (!this.hasMasterTarget) return
    const total = this.itemTargets.length
    const checked = this.itemTargets.filter((cb) => cb.checked).length
    this.masterTarget.checked = total > 0 && checked === total
    this.masterTarget.indeterminate = checked > 0 && checked < total
  }
}
